module.exports = {
  orderLabels: {
    pending: 'รอแจ้งโอน',
    confirmed: 'แจ้งโอนแล้ว',
    success: 'ซื้อสำเร็จ',
    cancel: 'ยกเลิก',
  },
  orderStatus: [
    {
      value: 'pending',
      name: 'รอแจ้งโอน',
    },
    {
      value: 'confirmed',
      name: 'แจ้งโอนแล้ว',
    },
    {
      value: 'success',
      name: 'ซื้อสำเร็จ',
    },
    {
      value: 'cancel',
      name: 'ยกเลิก',
    },
  ],
  paidUserPrizes: [
    {
      value: 'none',
      label: 'ยังไม่จ่ายเงิน',
    },
    {
      value: 'success',
      label: 'จ่ายเงินแล้ว',
    },
    {
      value: 'wrongInfo',
      label: 'ข้อมูลไม่ถูกต้อง',
    },
    {
      value: 'problem',
      label: 'โอนมีปัญหา',
    },
    {
      value: 'processing',
      label: 'กำลังโอน',
    },
    {
      value: 'error',
      label: 'เกิดข้อผิดพลาด',
    },
  ],

  agentTypes: [
    { value: 'agent', label: 'Agent' },
    { value: 'master', label: 'Master Agent' },
    { value: 'platinum', label: 'Platinum Agent' },
    { value: 'super-master', label: 'Super Master Agent' },
    { value: 'sub-master', label: 'Sub Master' },
  ],
  logs: [
    { value: 'create_order', label: 'สร้างคำสั่งซื้อ' }, //
    { value: 'approve_order', label: 'อนุมัติคำสั่งซื้อ' },
    { value: 'cancel_order', label: 'ยกเลิกคำสั่งซื้อ' },
    { value: 'change_order_owner', label: 'ย้ายคำสั่งซื้อ' },
    { value: 'create_admin', label: 'สร้างผู้ดูแลระบบ' },
    { value: 'update_user', label: 'แก้ไขข้อมูลลูกค้า' },
    { value: 'import_lotteries', label: 'นำเข้าลอตเตอรี่' },
    { value: 'send_sms', label: 'ส่ง sms' },
    { value: 'crawl_prize', label: 'ดึงข้อมูลรางวัล' },
    { value: 'create_prize', label: 'สร้างรางวัล' },
    { value: 'award_prize', label: 'แก้ไขสถานะจ่ายเงินรางวัล' },
    { value: 'update_config', label: 'แก้ไขข้อมูลระบบ' },
    { value: 'impersonate', label: 'เข้าใช้บัญชีลูกค้า' },
    { value: 'return_point_manual', label: 'คืนคะแนนลูกค้า' },
  ],

  config: [
    { value: 'slogan', flex: true, label: 'แสดง slogan' },
    { value: 'showResult', flex: true, label: 'แสดงรางวัล' },
    { value: 'roundDate', flex: true, label: 'ลอตเตอรี่รอบวันที่' },
    { value: 'isRoundClosed', flex: true, label: 'สถานะปิดรอบการขาย' },
    { value: 'limitPreOrder', flex: true, label: 'จำนวนลอตเตอรี่ที่จองได้' },
    { value: 'roundCloseDetail', flex: true, label: 'ตั้งค่าการปิดรอบ' },
    { value: 'isEnabledAffiliate', flex: true, label: 'เปิดระบบแนะนำเพื่อน' },
    { value: 'isEnabledPreOrder', flex: true, label: 'เปิดระบบพรีออเดอร์' },
    { value: 'isEnabledPoint', flex: true, label: 'เปิดระบบ​นกพอยต์' },
    {
      value: 'isEnableQRcode',
      flex: true,
      label: 'เปิดระบบโอนเงินรูปแบบ QR code',
    },
    { value: 'isEnableSlip', flex: true, label: 'เปิดระบบโอนเงินรูปแบบ slip' },
    { value: 'cartExpire', flex: true, label: 'เวลาหมดอายุตะกร้า', min: 5, max: 60 },
    { value: 'paymentExpire', flex: true, label: 'เวลาหมดอายุการโอน', min: 15, max: 60 },
    { value: 'qrHoldItemExpire', flex: true, label: 'เวลา QR หมดอายุคืนสินค้า', min: 15, max: 60 },
    { value: 'feePrice', flex: true, label: 'ค่าบริการ' },
    {
      value: 'emptyImage',
      flex: false,
      label: 'รูปภาพที่แสดงเมื่อลอตเตอรี่หมด',
    },
    { value: 'liveType', flex: true, label: 'ประเภท live' },
    { value: 'liveScan', flex: false, label: 'FacebookLive หน้าเคาน์ดาวน์' },
    { value: 'nextRound', flex: true, label: 'วันเปิดขายรอบหน้า' },
    { value: 'showBox', flex: true, label: 'เปิดการแสดงกล่อง' },
    { value: 'roundCloseImage', flex: false, label: 'รูปภาพแสดงเมื่อปิดรอบ' },
    {
      value: 'prizeTransferringMsg',
      flex: false,
      label: 'ข้อความแสดงขณะแจ้งโอน',
    },
    {
      value: 'noFee',
      flex: true,
      label: 'รหัสลูกค้าสำหรับซื้อลอตเตอรี่ 80 บาท',
    },
    { value: 'isEnableNokshop', flex: true, label: 'เปิดระบบ Nokshop' },
    { value: 'prizesShareCampaign', flex: true, label: 'โชคดีมีไว้แชร์' },
    { value: 'allowCharity', flex: true, label: 'เปิดหวยการกุศล' },
  ],

  configs: [
    { value: 'last-round-date', label: 'ประกาศรางวัลรอบวันที่', index: 1 },
    { value: 'show-result', label: 'แสดงรางวัล', index: 2 },
    { value: 'round-date', label: 'ลอตเตอรี่รอบวันที่', index: 3 },
    { value: 'order-round-date', label: 'แสดงคำสั่งซื้อรอบวันที่', index: 4 },
    { value: 'is-round-closed', label: 'สถานะปิดรอบการขาย', index: 5 },
    { value: 'round-close-detail', label: 'ตั้งค่าการปิดรอบ', index: 6 },
    { value: 'fee-price', label: 'ค่าบริการ', index: 7 },
    { value: 'market-price', label: 'ราคาตลาดที่รับซื้อ', index: 8 },
    { value: 'market-buy-date', label: 'รับซื้อวันที่', index: 9 },
    { value: 'enable-fee-price', label: 'เปิดใช้ค่าบริการ', index: 10 },
    {
      value: 'empty-image',
      label: 'รูปภาพที่แสดงเมื่อลอตเตอรี่หมด',
      index: 11,
    },
    { value: 'popup-image', label: 'รูปป็อปอัพหน้าแรก', index: 12 },
    { value: 'live-type', label: 'ประเภท live', index: 13 },
    { value: 'live-scan', label: 'FacebookLive หน้าเคาน์ดาวน์', index: 14 },
    { value: 'next-round-date-time', label: 'วันเปิดขายรอบหน้า', index: 15 },
    { value: 'is-bank-crawl-enabled', label: 'เปิดระบบตรวจสลิป', index: 16 },
    { value: 'top-news', label: 'ข่าวสารใต้เมนู', index: 17 },
    { value: 'agreement', label: 'คำยินยอม', index: 18 },
    { value: 'generate-test-id', label: 'รหัสทดสอบ', index: 19 },
    { value: 'show-box', label: 'เปิดการแสดงกล่อง', index: 20 },
    { value: 'disable-bank-transfer', label: 'ปิดระบบโอนเงิน', index: 21 },
    {
      value: 'is-enable-qrcode',
      label: 'ระบบโอนเงินรูปแบบ QR code',
      index: 22,
    },
    { value: 'is-enable-slip', label: 'ระบบโอนเงินรูปแบบ Slip', index: 23 },
    { value: 'is-enable-slot', label: 'เปิดระบบ Slot', index: 24 },
    { value: 'slot-price', label: 'ราคา Slot', index: 25 },
    { value: 'round-close-image', label: 'รูปภาพแสดงเมื่อปิดรอบ', index: 26 },
    {
      value: 'prize-transferring-msg',
      label: 'ข้อความแสดงขณะแจ้งโอน',
      index: 27,
    },
    { value: 'prizes-share-campaign', label: 'โชคดีมีไว้แชร์', index: 28 },
  ],

  permissions: [
    { value: 'dashboard', label: 'Dashboard' },
    { value: 'order', label: 'Order' },
    { value: 'config', label: 'Config' },
    { value: 'lottery', label: 'Lottery' },
    { value: 'admin', label: 'Admin' },
    { value: 'user', label: 'User' },
    { value: 'agent', label: 'Agent' },
    { value: 'withdrawal', label: 'Withdrawal' },

    { value: 'prize', label: 'Prize' },
    { value: 'log', label: 'Log' },
    { value: 'prize-announcement', label: 'Prize Announcement' },
  ],

  banks: {
    BBL: 'กรุงเทพ',
    KTB: 'กรุงไทย',
    BAY: 'กรุงศรีอยุธยา',
    KBANK: 'กสิกรไทย',
    CIMBT: 'ซีไอเอ็มบีไทย',
    KKP: 'เกียรตินาคินภัทร',
    TTB: 'ทหารไทยธนชาต',
    TISCO: 'ทิสโก้',
    SCB: 'ไทยพาณิชย์',
    UOBT: 'ยูโอบี',
    LHFG: 'แลนด์แอนด์ เฮ้าส์',
    ICBCT: 'ไอซีบีซี (ไทย)',
    TCD: 'ไทยเครดิตเพื่อรายย่อย',
    SME: 'พัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย',
    BAAC: 'เพื่อการเกษตรและสหกรณ์การเกษตร',
    EXIM: 'เพื่อการส่งออกและนำเข้าแห่งประเทศไทย',
    GSB: 'ออมสิน',
    GHB: 'อาคารสงเคราะห์',
    ISBT: 'อิสลามแห่งประเทศไทย',
    CLICX: 'คลิกซ์',
  },
  bankCode: {
    BBL: '002',
    KBANK: '004',
    KTB: '006',
    TMB: '011',
    TTB: '011',
    SCB: '014',
    BAY: '025',
    KKP: '069',
    CIMBT: '022',
    TISCO: '067',
    TBANK: '011',
    TBNK: '011',
    UOBT: '024',
    TCD: '071',
    LHFG: '073',
    ICBCT: '070',
    SME: '098',
    BAAC: '034',
    EXIM: '035',
    GSB: '030',
    GSBA: '030',
    GHB: '033',
    ISBT: '066',
    CLICX: '088',
  },

  BANK_LENGTH: {
    BBL: { accountMinLength: 10, accountMaxLength: 10 },
    KTB: { accountMinLength: 10, accountMaxLength: 10 },
    BAY: { accountMinLength: 10, accountMaxLength: 10 },
    KBANK: { accountMinLength: 10, accountMaxLength: 10 },
    CIMBT: { accountMinLength: 10, accountMaxLength: 10 },
    KKP: { accountMinLength: 10, accountMaxLength: 14 },
    TTB: { accountMinLength: 10, accountMaxLength: 10 },
    TISCO: { accountMinLength: 14, accountMaxLength: 14 },
    SCB: { accountMinLength: 10, accountMaxLength: 10 },
    UOBT: { accountMinLength: 10, accountMaxLength: 10 },
    LHFG: { accountMinLength: 10, accountMaxLength: 10 },
    ICBCT: { accountMinLength: 10, accountMaxLength: 10 },
    TCD: { accountMinLength: 10, accountMaxLength: 10 },
    SME: {},
    BAAC: { accountMinLength: 10, accountMaxLength: 12 },
    EXIM: {},
    GSB: { accountMinLength: 12, accountMaxLength: 15 },
    GHB: { accountMinLength: 12, accountMaxLength: 12 },
    ISBT: { accountMinLength: 10, accountMaxLength: 10 },
    CLICX: { accountMinLength: 10, accountMaxLength: 10 },
  },

  paymentMethods: {
    cc: 'Credit Card',
    transfer: 'Bank Transfer',
    admin: 'Created By Admin',
    credit: 'Credit',
  },

  prizes: [
    {
      label: 'รางวัลที่ 1',
      name: 'first',
    },
    {
      label: 'รางวัลข้างเคียงรางวัลที่ 1',
      name: 'nearBy',
    },
    {
      label: 'รางวัลเลขท้าย 2 ตัว',
      name: 'last2Digits',
    },
    {
      label: 'รางวัลเลขท้าย 3 ตัว',
      name: 'last3Digits',
    },
    {
      label: 'รางวัลเลขหน้า 3 ตัว',
      name: 'first3Digits',
    },

    {
      label: 'รางวัลที่ 2',
      name: 'second',
    },
    {
      label: 'รางวัลที่ 3',
      name: 'third',
    },
    {
      label: 'รางวัลที่ 4',
      name: 'forth',
    },
    {
      label: 'รางวัลที่ 5',
      name: 'fifth',
    },
  ],
  monthTH: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
  fullMonthTH: [
    'มกราคม',
    'กุมภาพันธ์',
    'มีนาคม',
    'เมษายน',
    'พฤษภาคม',
    'มิถุนายน',
    'กรกฏาคม',
    'สิงหาคม',
    'กันยายน',
    'ตุลาคม',
    'พฤศจิกายน',
    'ธันวาคม',
  ],

  permissionsAdmin: {
    CEO: {
      label: 'CEO',
      permission: [
        'announcements',
        'dashboard',
        'fcm',
        'campaign',
        'adBanner',
        'lotteryLive',
        'dashboard-draft',
        'highlightLottery',
        'lotteryCountByNumber',
      ],
    },
    superAdmin: {
      label: 'superAdmin',
      permission: [
        'dashboard-draft',
        'order',
        'payment',
        'preOrder',
        'cancelPaymentSuccess',
        'user',
        'userPrizes',
        'prize',
        'lottery',
        'lotteryLive',
        'lotteryTemp',
        'admin',
        'dashboard',
        'coupon',
        'log',
        'transfer',
        'refunds',
        'withdrawal',
        'config',
        'bookBankCollection',
        'prize-announcement',
        'affiliate',
        'withdrawalRequest',
        'transferSlip',
        'books',
        'scaning',
        'round',
        'monitor',
        'numberOfPrizes',
        'gifts',
        'fcm',
        'campaign',
        'adBanner',
        'orderExtras',
        'tempImport',
        'badQR',
        'moveLottery',
        'refund',
        'recheckShipping',
        'openBox',
        'highlightLottery',
        'kyc',
        'lotterySafe',
        'lotteryCountByNumber',
        'recheckPrizes2',
      ],
    },
    adminHelper: {
      label: 'adminHelper',
      permission: [
        'order',
        'payment',
        'preOrder',
        'user',
        'userPrizes',
        'prize',
        'lottery',
        'admin',
        'dashboard',
        'log',
        'transfer',
        'refunds',
        'withdrawal',
        'prize-announcement',
        'affiliate',
        'withdrawalRequest',
        'transferSlip',
        'gifts',
        'orderExtras',
        'moveLottery',
        'refund',
        'openBox',
        'kyc',
        'lotterySafe',
        'lotteryCountByNumber',
        'recheckPrizes2',
      ],
    },
    marketing: {
      label: 'marketing',
      permission: [
        'dashboard',
        'order',
        'payment',
        'preOrder',
        'user',
        'userPrizes',
        'prize',
        'lottery',
        'lotteryLive',
        'transfer',
        'transferSlip',
        'affiliate',
        'campaign',
        'adBanner',
        'luckyNumber',
        'orderExtras',
        'highlightLottery',
        'lotteryCountByNumber',
      ],
    },
    support: {
      label: 'support',
      permission: [
        'order',
        'payment',
        'preOrder',
        'user',
        'userPrizes',
        'prize',
        'lottery',
        'transfer',
        'refunds',
        'transferSlip',
        'affiliate',
        'gifts',
        'orderExtras',
        'withdrawalRequest',
        'moveLottery',
        'refund',
        'lotterySafe',
        'lotteryCountByNumber',
      ],
    },
    scaningTeam: {
      label: 'scaningTeam',
      permission: [
        'badQR',
        'lottery',
        'lotteryLive',
        'log',
        'books',
        'scaning',
        'round',
        'monitor',
        'prize',
        'numberOfPrizes',
        'tempImport',
        'recheckPrizes',
        'recheckPrizes2',
        'recheckShipping',
        'lotterySafe',
        'lotteryCountByNumber',
      ],
    },
    scaningTeamPlus: {
      label: 'scaningTeamPlus',
      permission: [
        'badQR',
        'lottery',
        'lotteryLive',
        'log',
        'books',
        'scaning',
        'round',
        'monitor',
        'prize',
        'preOrder',
        'lotteryTemp',
        'numberOfPrizes',
        'tempImport',
        'recheckPrizes',
        'recheckPrizes2',
        'fcm',
        'config',
        'recheckShipping',
        'openBox',
        'lotterySafe',
        'lotteryCountByNumber',
      ],
    },
    programmer: {
      label: 'programmer',
      permission: [
        'dashboard-draft',
        'badQR',
        'announcements',
        'luckyNumber',
        'order',
        'payment',
        'cancelPaymentSuccess',
        'preOrder',
        'user',
        'userPrizes',
        'prize',
        'lottery',
        'lotteryLive',
        'lotteryTemp',
        'admin',
        'dashboard',
        'dashboardScan',
        'campaign',
        'adBanner',
        'log',
        'transfer',
        'refunds',
        'agent',
        'withdrawal',
        'config',
        'bookBankCollection',
        'coupon',
        'prize-announcement',
        'affiliate',
        'kyc',
        'withdrawalRequest',
        'transferSlip',
        'fcm',
        'books',
        'scaning',
        'round',
        'monitor',
        'numberOfPrizes',
        'tempImport',
        'gifts',
        'transferMhee',
        'payOutMhee',
        'transferFinance',
        'recheckPrizes',
        'orderExtras',
        'recheckPrizes2',
        'refund',
        'moveLottery',
        'recheckShipping',
        'openBox',
        'highlightLottery',
        'editPolicy',
        'lotterySafe',
        'programmer-permissions',
        'lotteryCountByNumber',
      ],
    },
    mhee: {
      label: 'mhee',
      permission: [
        'dashboard-draft',
        'announcements',
        'luckyNumber',
        'userPrizes',
        'prize',
        'lottery',
        'admin',
        'dashboard',
        'campaign',
        'adBanner',
        'log',
        'config',
        'prize-announcement',
        'affiliate',
        'withdrawalRequest',
        'fcm',
        'gifts',
        'transferMhee',
        'payOutMhee',
      ],
    },
    finance: {
      label: 'finance',
      permission: ['transferFinance'],
    },
  },
  fcmTopics: ['kslplusLotteryDueDate', 'testkslplusTest4-12-64'],
  fcmType: [
    { label: 'Promotion', value: 'promotion' },
    { label: 'Success', value: 'success' },
    { label: 'Fail', value: 'fail' },
  ],
}
